// @core/api/endpoints/authz/read_authorization_model.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ReadAuthorizationModelResponse,
} from '../../../types/authz';

const BASE_PATH = '/authz';

/**
 * Get authorization model
 * Retrieves a specific authorization model by its ID. If no ID is provided, returns the latest active model. The model defines all type definitions and relations used for authorization checks.
 */
export async function ReadAuthorizationModel(
  id: string,
  options?: RequestOptions
): Promise<ReadAuthorizationModelResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/models/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<ReadAuthorizationModelResponse>(requestPath, { ...requestOptions });
}
